<form [formGroup]="addFilterForm">
  <div class="d-flex row">
    <div class="col-4 col-md-4 col-sm-4 col-xs-4">Field Name</div>
    <div class="col-8 col-md-8 col-sm-8 col-xs-8">
      <select id="filterName" (change)="onFieldSelected()" class="form-control select-btn" required formControlName="filterName">
        <option *ngFor="let element of filterList" [ngValue]="element" [hidden]="hideFieldName(globalService.replaceFilterText(element.fieldName))">{{element.fieldName}}</option>
      </select>
    </div>
    <div class="col-4 col-md-4 col-sm-4 col-xs-4 mt-2">Condition</div>
    <div class="col-8 col-md-8 col-sm-8 col-xs-8 mt-2">
      <select id="condition" (change)="onConditionSelected()" class="form-control select-btn" required formControlName="condition">
        <option *ngFor="let element of conditionList" [ngValue]="element">{{element}}</option>
      </select>
    </div>
    <div class="col-4 col-md-4 col-sm-4 col-xs-4 mt-2">Value</div>
    <div class="col-8 col-md-8 col-sm-8 col-xs-8 mt-2">
      <select id="value" class="form-control select-btn select-checkbox" required formControlName="value" [multiple]="conditionList?.length>=1">
        <option *ngFor="let element of valuesList" [ngValue]="element" [disabled]="disableValues(element)">{{element}}</option>
      </select>
    </div>
    <div class="col-4 col-md-4 col-sm-4 col-xs-4 mt-2"></div>
    <div class="col-8 col-md-8 col-sm-8 col-xs-8 mt-2 align-self-center">
      <button class="btn btn-primary" (click)="submitFilter()">Apply</button>
    </div>
  </div>
</form>
